import React, { FC } from "react";
import cn from "classnames";

interface Props {
  title: string;
  childrenClassName?: string;
  children?: React.ReactNode;
}

export const ProfileInfoBlock: FC<Props> = ({
  title,
  childrenClassName,
  children,
}) => (
  <div>
    <h4 className="text-purple-base font-monument-extended">{title}</h4>
    <div className={cn("mt-2", childrenClassName)}>{children}</div>
  </div>
);
